import './Input.css';

const Input = ({ className = '', ...props }) => {
  return <input type="text" {...props} className={`input ${className}`} />;
};

export default Input;
